var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,13.432c0-3.061,1.155-5.92,3.354-8.101l1.925-1.668c2.218-2.218,5.811-2.218,8.029,0,.055.055,3.446,4.472,3.446,4.472,2.108,2.181,2.108,5.663,0,7.844l-2.126,2.676c2.676,6.066,6.837,10.245,12.703,12.738l2.676-2.144c2.181-2.089,5.646-2.089,7.845,0,0,0,4.418,3.391,4.473,3.446,2.218,2.218,2.218,5.81.092,7.936l-1.833,2.108c-2.108,2.108-4.968,3.262-8.029,3.262-13.986,0-32.555-18.548-32.555-32.55v-.018Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCall);
export default __webpack_public_path__ + "static/media/icon-call.d7a2a1754d92be81fbce327751685d35.svg";
export { ForwardRef as ReactComponent };